import { useTranslation } from 'next-i18next';
import { useLocale } from '@hooks/useLocale';
export const useIceChat = () => {
  const locale = useLocale();
  const { t } = useTranslation();

  const isEnglish = locale !== 'fr';

  const openChat = () => {
    const loginUrl = `${
      process.env.NEXT_PUBLIC_ICECHAT_DOMAIN
    }/Custom/iceMessaging/${isEnglish ? '' : '?lang=fr-CA'}`;
    window.open(
      loginUrl,
      t('contact.livechat.button'),
      'width=490, height=760, resizable=yes, scrollbars=yes'
    );
  };

  return openChat;
};
